<template>
  <transition :name="transition">
    <div class="flexi-tooltip">
      <li
        class="flexi-tooltip--item"
        :class="isInner ? 'inner' : ''"
        v-text="tooltip"
      />
    </div>
  </transition>
</template>

<script>
export default {
  name: "FlexiTooltip",
  props: {
    isInner: Boolean,
    tooltip: String,
    transition: {
      type: String,
      default: () => {
        return "fade";
      }
    }
  }
};
</script>
